<template>
  <div v-show="isVisible">
    <div class="title">Описание услуги:</div>
    <div class="dop-info">
      <div>
        <div class="fieldset">
          <label class="fieldset-title">Время прибытия</label>
          <fieldset>
            <input type="text" class="time" placeholder="hh:mm" v-mask="'##:##'" v-model="time">
          </fieldset>
        </div>
        <div class="fieldset">
          <label class="fieldset-title long-title">Клиентское время<br> (прогноз)</label>
          <fieldset :class="[ { 'fieldset-error' : invalidClientTime } ]">
            <input type="text" class="time" v-mask="'##:##'" v-model="clientTime" placeholder="hh:mm" @blur="checkClientTime">
            <span v-if="invalidClientTime" class="error-text">
              Введённое время меньше минимального ( {{this.currentService.category.minDuration}}ч )
            </span>
          </fieldset>
        </div>
      </div>
    </div>
    <div class="title">Адреса:</div>
    <div class="address-section">
      <div class="selected-address-form" v-show="furnitureServiceAddresses.length > 0">
        <div class="fieldset">
          <draggable v-model="furnitureServiceAddresses">
            <div class="address" v-for="address in furnitureServiceAddresses">
              <fieldset class="address-fieldset">
                <input type="text" :value="displayAddress(address)" readonly>
              </fieldset>
              <span class="move-button" title="Переместить"><img src="../image/move.svg"></span>
            </div>
          </draggable>
        </div>
      </div>
      <div class="fieldset select-address-button">
        <div class="add-address" @click="showAddressesFromOrder = true"><span
          class="icon">+</span>Выбрать адреса
        </div>
      </div>
      <div class="select-address-form" v-show="showAddressesFromOrder">
        <div class="fieldset">
          <div class="address" v-for="(address, index) in addressesFromOrder">
            <fieldset class="address-fieldset">
              <input type="text" :value="displayAddress(address)" readonly>
            </fieldset>
            <label class="checkbox-label"><input type="checkbox" @change="addOrRemoveAddress(index, $event)"
                                                 v-model="checkboxesForAddressesFromOrder[index]">выбрать</label>
          </div>
        </div>
        <div class="buttons">
          <button type="button" @click="showAddressesFromOrder = false">Готово</button>
        </div>
      </div>
    </div>
    <div class="buttons">
      <button type="button" class="save-button" @click="saveChanges">Сохранить</button>
    </div>
  </div>
</template>
<script>
  import Timepicker from 'vue2-timepicker'
  import api from '@/api'
  import draggable from 'vuedraggable'
  import utils from '@/utils'
  import {mask} from 'vue-the-mask'

  export default {
  name: 'FurnitureService',
  props: ['isVisible', 'index', 'isNew', 'count', 'addressesFromOrder', 'orderDateTime'],

  components: {
    Timepicker,
    draggable
  },

  directives: { mask },

  data () {
    return {
      newFurnitureService: {
        type: 'OrderToFurniture',
        pathToClass: 'ru.itbrick.shustrikoffcrm.beans.OrderToFurniture',
        clientTime: null,
        predictionTime: null,
        date: 0
      },

      furnitureService: {
        clientTime: null,
        predictionTime: null,
        date: 0
      },

      furnitureCategories: [],
      furnitureServiceAddresses: [],
      showAddressesFromOrder: false,
      checkboxesForAddressesFromOrder: []
    }
  },

  computed: {
    currentService: {
      get () {
        return this.isNew
          ? this.newFurnitureService
          : this.furnitureService
      },

      set (service) {
        if (this.isNew) {
          this.newFurnitureService = service
        } else {
          this.furnitureService = service
        }
      }
    },

    time: {
      get () {
        return utils.getFormattedTimeStringFromLongWithoutTimezone(this.currentService.date)
      },

      set (value) {
        if (value.length == 5) {
          let date = new Date(this.currentService.date)
          date.setHours(0, 0, 0, 0)
          this.currentService.date = new Date(date.getTime() + utils.getLongFromFormattedTimeString(value)).getTime()
        }
      }
    },

    clientTime: {
      get () {
        return utils.getFormattedTimeStringFromLongWithoutTimezone((new Date()).setHours(0, 0, 0, 0) + (this.currentService.clientTime))
      },

      set (value) {
        if (value.length === 5) { this.currentService.clientTime = utils.getLongFromFormattedTimeString(value) }
      }
    },

    invalidClientTime: {
      get () {
        return this.currentService.category &&
            this.currentService.clientTime < this.currentService.category.minDuration * 3600000
      }
    },

    furnitureServiceAddressesCoords () {
      return this.furnitureServiceAddresses.map((address) => utils.getCoordsStringOfAddress(address))
    }
  },

  watch: {
    isVisible (val) {
      if (val) {
        if (!this.isNew) {
          this.furnitureService = Object.assign({}, this.$store.getters.groupedServices[this.index][0])

          this.furnitureServiceAddresses = []
          if (this.furnitureService.addresses != null) {
            this.furnitureServiceAddresses.push.apply(this.furnitureServiceAddresses, this.furnitureService.addresses)
          }

          this.checkboxesForAddressesFromOrder = this.fillAddressesFromOrderCheckboxes()
        } else {
          this.newFurnitureService = {
            type: 'OrderToFurniture',
            pathToClass: 'ru.itbrick.shustrikoffcrm.beans.OrderToFurniture',
            clientTime: null,
            predictionTime: null,
            date: this.orderDateTime,
            category: this.furnitureCategories[0]
          }

          this.newFurnitureService.clientTime = this.newFurnitureService.category.minDuration * 3600000

          if (this.$store.getters.groupedServices.length > 0) {
            let mainServices = this.$store.getters.groupedServices.filter(gs => gs[0].type != 'OrderToAdditional')

            if (mainServices.length > 0) {
              let previousService = mainServices[mainServices.length - 1][0]

              if (previousService.clientTime) {
                if(previousService.clientTime >= this.newFurnitureService.clientTime && previousService.clientTime !== 24 * 60 * 60 * 1000) {
                  this.newFurnitureService.clientTime = previousService.clientTime
                }
              }

              if (previousService.addresses && previousService.addresses.length > 0 && previousService.type != 'OrderToPetrol') {
                this.newFurnitureService.addresses = previousService.addresses
                  .filter(address => address.lat != null && address.lng != null)
                  .map(address => Object.assign({}, address))
              }
            }

            this.furnitureServiceAddresses = this.newFurnitureService.addresses
              ? this.newFurnitureService.addresses : []
            this.checkboxesForAddressesFromOrder = this.fillAddressesFromOrderCheckboxes()
          }
        }
        this.showAddressesFromOrder = false
      }
    }
  },

  mounted () {
    api
      .getFurnitureCategories()
      .then(furnitureCategories => {
        if (furnitureCategories) {
          this.furnitureCategories = []
          this.furnitureCategories = furnitureCategories
        }
      })
  },

  methods: {
    displayAddress (address) {
      if (!address || !address.place)
        return '';
      return utils.getSmallAddressFromFull(address.place)
        + (address.comment ? (' ' + address.comment) : '');
    },

    addOrRemoveAddress (index, e) {
      let tmpAddress = Object.assign({}, this.addressesFromOrder[index]);

      if (e.target.checked) {
        this.furnitureServiceAddresses.push(tmpAddress)
      } else {
        let addressFormOrderCoords = utils.getCoordsStringOfAddress(tmpAddress)
        let removeAddressIndex = this.furnitureServiceAddressesCoords.indexOf(addressFormOrderCoords)
        if (removeAddressIndex > -1) {
          this.furnitureServiceAddresses.splice(removeAddressIndex, 1)
        }
      }
    },

    fillAddressesFromOrderCheckboxes () {
      return this.addressesFromOrder.map(addressFromOrder => {
        return this.serviceAddressesHaveAddressAlready(addressFromOrder)
      })
    },

    serviceAddressesHaveAddressAlready (addressFromOrder) {
      let addressFormOrderCoords = utils.getCoordsStringOfAddress(addressFromOrder)
      return this.furnitureServiceAddressesCoords.indexOf(addressFormOrderCoords) != -1
    },

    saveChanges () {
      let promise
      if (this.isNew) {
        promise = this.addNewService()
      } else {
        promise = this.updateService()
      }
      this.$store.commit('addNewGroupedServicesPromise', promise)
      this.clearAddresses()
      this.$emit('close-window', false)
    },

    clearAddresses () {
      this.furnitureServiceAddresses = []
      this.checkboxesForAddressesFromOrder = []
    },

    updateService () {
      return new Promise(resolve => {
        // при коммите в store index из property является undefined
        let index = this.index
        let count = this.count

        let addresses = this.furnitureServiceAddresses.map((item, i) => {
          item.orderNum = i
          return item
        })

        let serviceData = {
          addresses: addresses,
          date: this.furnitureService.date,
          clientTime: this.furnitureService.clientTime,
          predictionTime: this.furnitureService.predictionTime
        }

        utils.spotRegionAndDistrictByAddresses(this.furnitureServiceAddresses, this.$store.getters.regions, this.$store.getters.districts)
          .then(regionDistrictData => {
            Object.assign(serviceData, regionDistrictData)

            this.$store.dispatch('updateGroupedServiceByIndex', {
              index: index,
              count: count,
              serviceData: serviceData
            }).then(() => resolve())
          })
      })
    },

    addNewService () {
      return new Promise(resolve => {
        this.newFurnitureService.addresses = this.furnitureServiceAddresses.map((item, i) => {
          item.id = 0
          item.orderNum = i
          return item
        })

        utils.spotRegionAndDistrictByAddresses(this.furnitureServiceAddresses, this.$store.getters.regions, this.$store.getters.districts)
          .then(regionDistrictData => {
            Object.assign(this.newFurnitureService, regionDistrictData)

            let groupedService = []
            for (let i = 0; i < this.count; i++) { groupedService.push(Object.assign({}, this.newFurnitureService)) }

            this.$store.dispatch('addNewGroupedService', groupedService).then(() => resolve())
          })
      })
    },

    checkClientTime ($event) {
      if ($event.target.value > 23) {
        this.currentService.clientTime = 82800000
      }
    }
  }
}
</script>
